__turbopack_context__.v({
  "contentColumn": "ImageItemListSection-module__Quy4JG__contentColumn",
  "description": "ImageItemListSection-module__Quy4JG__description",
  "eyebrow": "ImageItemListSection-module__Quy4JG__eyebrow",
  "glassBody": "ImageItemListSection-module__Quy4JG__glassBody",
  "glassCard": "ImageItemListSection-module__Quy4JG__glassCard",
  "glassEyebrow": "ImageItemListSection-module__Quy4JG__glassEyebrow",
  "glassTitle": "ImageItemListSection-module__Quy4JG__glassTitle",
  "header": "ImageItemListSection-module__Quy4JG__header",
  "heading": "ImageItemListSection-module__Quy4JG__heading",
  "inner": "ImageItemListSection-module__Quy4JG__inner",
  "item": "ImageItemListSection-module__Quy4JG__item",
  "itemButton": "ImageItemListSection-module__Quy4JG__itemButton",
  "itemDescBloomIn": "ImageItemListSection-module__Quy4JG__itemDescBloomIn",
  "itemDescription": "ImageItemListSection-module__Quy4JG__itemDescription",
  "itemList": "ImageItemListSection-module__Quy4JG__itemList",
  "itemSeparator": "ImageItemListSection-module__Quy4JG__itemSeparator",
  "itemTitle": "ImageItemListSection-module__Quy4JG__itemTitle",
  "mediaCard": "ImageItemListSection-module__Quy4JG__mediaCard",
  "mediaColumn": "ImageItemListSection-module__Quy4JG__mediaColumn",
  "mediaImage": "ImageItemListSection-module__Quy4JG__mediaImage",
  "mobileMediaCard": "ImageItemListSection-module__Quy4JG__mobileMediaCard",
  "mobileMediaImage": "ImageItemListSection-module__Quy4JG__mobileMediaImage",
  "plusIcon": "ImageItemListSection-module__Quy4JG__plusIcon",
  "section": "ImageItemListSection-module__Quy4JG__section",
});
